
  import { Vue, Component, Prop } from "vue-property-decorator";
  import BadgeColor from "@/entities/BadgeColor";
  import Badge from "@/components/common/Badge.vue";

  @Component({
    components: {
      Badge,
    },
  })
  export default class ManagerAccessBadges extends Vue {
    @Prop({ type: Boolean, default: false }) readonly isAccessGranted!: boolean;
    @Prop({ type: Boolean, default: false }) readonly isContractorRequested!: boolean;

    BadgeColor = BadgeColor;
  }
